import { message as antdMessage } from "antd";
import styles from "@ui/components/toast/css/message.module.css";

interface IMessageArgs {
  content: string;
  duration?: number;
  type: "info" | "success" | "error" | "warning";
}

export function message({ content, duration = 3, type }: IMessageArgs) {
  antdMessage[type]({
    className: styles.message,
    content,
    duration,
    type,
  });
}
